import PropTypes from 'prop-types';
import { Component } from 'react';

import css from 'styles/components/productdetail/ask/itemForm.scss';

/**
 * This form is for both asking questions and writing answers. It knows which
 * one it is because an instance created for the "ask a question" element has a
 * questionKey prop of `null`. Instances created for "write an answer" elements
 * have the key of the question they answer as their questionKey prop.
 */
export default class ItemForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.authRedirect = this.authRedirect.bind(this);
    this.keyRedirect = this.keyRedirect.bind(this);
  }

  state = { value: '' };

  authRedirect() {
    this.props.onAskAuthRedirect();
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    const { onSubmitAskItem, questionKey } = this.props;
    event.preventDefault();
    onSubmitAskItem(questionKey, this.state.value);
    this.setState({ value: '' });
  }

  keyRedirect(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.authRedirect();
    }
  }

  renderNotAuthenticated() {
    const { onAskAuthRedirect, questionKey } = this.props;
    const anchorProps = { tabIndex: '0', onClick: onAskAuthRedirect, onKeyDown: this.keyRedirect };

    if (questionKey) {
      return (
        <p className={css.notAuthedMessage}>
          You need to be
          {' '}
          <a {...anchorProps}>signed in</a> or <a {...anchorProps}>create an account</a>
          {' '}
          before answering a question.
        </p>
      );
    } else {
      return (
        <p className={css.notAuthedMessage}>
          Please <a {...anchorProps}>Log In</a> or <a {...anchorProps}>Create
          An Account</a> to post a question.
        </p>
      );
    }
  }

  render() {
    if (!this.props.authenticated) {
      return this.renderNotAuthenticated();
    }

    const { questionKey } = this.props;
    const submitText = questionKey ? 'Submit' : 'Ask';

    const textareaProps = {
      className: css.textarea,
      value: this.state.value,
      onChange: this.handleChange,
      placeholder: this.props.textareaPlaceholder,
      maxLength: '300'
    };

    return (
      <form method="post" className={css.form} onSubmit={this.handleSubmit}>
        {!questionKey && (
          <div className={css.askQuestionTopText}>
            <p>Have a question about this item? Want to get insights from others who bought it? Ask here!</p>
            <p>You'll be notified by email when someone's answered your question.</p>
            <label className={css.yourQuestionLabel} htmlFor={submitText}>Your Question</label>
          </div>
        )}
        {questionKey && (
          <label className={css.yourQuestionLabel} htmlFor={submitText}>Your Answer</label>
        )}
        <textarea {...textareaProps} id={submitText}/>
        <input className={css.submit} type="submit" value={submitText}/>
      </form>
    );
  }
}

ItemForm.propTypes = {
  onSubmitAskItem: PropTypes.func.isRequired,
  onAskAuthRedirect: PropTypes.func.isRequired,

  questionKey: PropTypes.string,
  textareaPlaceholder: PropTypes.string.isRequired,
  authenticated: PropTypes.bool.isRequired
};
